import { createContext, useContext } from 'react';
import { tGlobalBannerContext } from './GlobalBanner.types';

export const GlobalBannerContext = createContext<tGlobalBannerContext>({
  showBanner: () => {},
  dismissBanner: () => {},
  getBannersForModule: () => [],
});

export function useGlobalBannerContext(): tGlobalBannerContext {
  return useContext(GlobalBannerContext);
}
